import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import ServiceFooter from './footer';
import ServiceHeader from './header';

const ServiceDetails = () => {
    const location = useLocation();
    const { primaryId, product } = location.state || {};
    const navigate = useNavigate();

    const [selectedSlot] = useState(null); // State to track the selected slot

    const handleNavigateToInquire = () => {
        navigate('enquire-now', { state: { primaryId, product } });
    };

    const handleNavigateToBook = () => {
        navigate('/book-schedule', {
            state: {
                primaryId,
                product,
                selectedSlot,
            },
        });
    };

    return (
        <>
            <ServiceHeader />
            <br />
            <div className="flex flex-col md:flex-row h-auto md:h-screen">
                {/* Left Section: Image */}
                <div className="md:flex-1 relative h-64 md:h-full">
                    <img
                        src={product?.imageUrlsList?.[0] || 'https://via.placeholder.com/600x600'}
                        alt={product?.name || 'Product Image'}
                        className="w-full h-full object-cover"
                    />
                </div>

                {/* Right Section: Text Content */}
                <div className="md:flex-1 bg-white p-8 md:p-16 flex flex-col justify-center">
                    <h1 className="text-4xl font-bold leading-tight mb-6">
                        {product?.name || 'Service Name'}
                    </h1>
                    <p className="text-gray-600 mb-6">
                        {product?.description || 'No description available.'}
                    </p>

                    <p className="text-gray-600 mb-4">
                        <strong>Type:</strong> {product?.category?.name || 'Uncategorized'}
                    </p>
                    <p className="text-gray-600 mb-4">
                        <strong>Price:</strong>{' '}
                        {product?.price?.currency
                            ? `${product.price.currency} ${product.price.priceAmt}`
                            : `$${product?.price?.priceAmt || '0'}`}
                    </p>

                    {/* Buttons */}
                    <div className="flex flex-col sm:flex-row gap-4 mt-6">
                        <button
                            id="get-in-touch-button"
                            className="bg-yellow-500 text-black font-medium px-6 py-2 rounded hover:bg-yellow-600"
                            onClick={handleNavigateToInquire}
                        >
                            Get in touch
                        </button>
                        <button
                            id="book-now-button"
                            className="bg-yellow-500 text-black font-medium px-6 py-2 rounded hover:bg-yellow-600"
                            onClick={handleNavigateToBook}
                        >
                            Book now
                        </button>
                    </div>
                </div>
            </div>
            <ServiceFooter />
        </>
    );
};

export default ServiceDetails;
